import React from 'react'
import CustomLink from '../components/CustomLink'
import AuthLayout from './AuthLayout'
import globals from '../globals'
import ForgotUsernameForm from '../forms/ForgotUsernameForm'

class ForgotUsername extends React.Component {
    render () {
        return (
            <AuthLayout
                title='Forgot your username'
                description="If you have forgotten your username, enter your details below and we will email your account username to you.<br /><br /><span class='bold'>You can find your Customer Number (ID) on your Exetel invoice or on an email we have sent you in the past.</span>"
            >
                <ForgotUsernameForm
                    handleSuccess={() => globals.pushEvent('ResetUsernameRequest')}
                />
                <div className='row'>
                    <div className='col-12 text-center mt-5'>
                        <small>Return to <CustomLink to='/login' className='return-to'>My Exetel</CustomLink></small>
                    </div>
                </div>
            </AuthLayout>
        )
    }
}

export default ForgotUsername



// WEBPACK FOOTER //
// ./resources/js/auth/ForgotUsername.js